<script lang="ts" setup>
  import { ExternalRoute } from "@/constants/externalRoute"
  import Link from "@/components/ui/link/Link.vue"
</script>
<template>
  <h4>We're sorry you've not been happy with our service.</h4>
  <p>
    When signing up to So Energy, you should receive a couple of emails about
    your switch and activating your account. If you haven't received these,
    please check your email spam or junk folders, see our
    <Link
      :to="ExternalRoute.switchingProcessSupportArticle"
      class="link text-primary-600"
    >
      switching guide
    </Link>
    , or
    <Link :to="ExternalRoute.contactUs" class="link text-primary-600">
      contact us
    </Link>
    for more help.
  </p>
  <p>
    After switching you shouldn't get many emails from us unless you want to
    sign up to our marketing communications. If you'd like to get these emails
    you can sign up below!
  </p>
  <p>
    You can also activate emails like meter reading reminders by
    <Link :to="ExternalRoute.personalDetails" class="link text-primary-600">
      changing your preferences in your account.
    </Link>
  </p>
</template>
